<template>
    <div>
        <div  @click="$set(openQuiz, userQuiz.id, true);">
        <div
            class="d-flex justify-content-between align-items-center second-course-container action-menu">
            <div class="dashboard-coursename">
                <span
                    :title="userQuiz.quiz.name ? userQuiz.quiz.name : trans('course.untitled.' + userQuiz.quiz.quiz_type)">
                    {{ userQuiz.quiz.name ? userQuiz.quiz.name : trans('course.untitled.' +
                            userQuiz.quiz.quiz_type)
                    }}
                </span>
            </div>
            <student-quiz-viewer :open="openQuiz?.[userQuiz.id]"
                @close="$set(openQuiz, userQuiz.id, false);" :user-quiz="userQuiz"
                :student-course="userQuiz.student_course"></student-quiz-viewer>
        </div>
        <template v-if="userQuiz.quiz.quiz_type === 'essay' && resultsAvailableNow">
            <div v-if="userQuiz.responses !== null && userQuiz.teacher_points === null"
                class="alert alert-warning p-0">
                Essay pending
            </div>
            <div v-else :class="{
                'alert alert-danger p-0': !userQuiz.passed,
                'alert alert-success p-0': userQuiz.passed
            }">
                {{ trans("course.student_quiz_your_score") }}: {{ userQuiz.quiz.min_score_type ===
                        'percent' ? userQuiz.teacher_points + '%' : userQuiz.teacher_points
                }}
                (min. {{ userQuiz.quiz.min_score_type === 'percent' ? userQuiz.quiz.min_score + '%' :
                        userQuiz.quiz.min_score
                }})
            </div>
        </template>
        <div v-if="userQuiz.quiz.quiz_type === 'quiz' && resultsAvailableNow" :class="{
            'alert alert-danger p-0': !userQuiz.passed,
            'alert alert-success p-0': userQuiz.passed
        }">
            {{ trans("course.student_quiz_your_score") }}: {{ userQuiz.quiz.min_score_type === 'percent'
                    ?
                    userQuiz.percent + '%' : userQuiz.points
            }}
            (min. {{ userQuiz.quiz.min_score_type === 'percent' ? userQuiz.quiz.min_score + '%' :
                    userQuiz.quiz.min_score
            }})
        </div>
        <p class="training-name-quiz-info quiz-score-container">
            {{ userQuiz.student_course.course.name }} {{ userQuiz.student_course.training ? ' (' +
                    userQuiz.student_course.training.title + ')' : ''
            }}
        </p>
        </div>
        
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        userQuiz: {
            type: Object,
            required: true,
        }
    },
    computed: {
        resultsAvailableNow: function () {
            return !this.userQuiz.delay_results_until || moment(this.userQuiz.delay_results_until) <= moment();
        },
    },
    data: () => ({
        openQuiz: {},
    })
}
</script>
